/* eslint-disable no-irregular-whitespace */
import * as React from 'react';
import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export const BuyModal: React.FC = () => {
  return (
    <div className={styles['container']}>
      <ArticleHeading2>Покупка </ArticleHeading2>

      <ArticleParagraph1>Стоимость услуг риелтора на вторичном рынке обычно зависит от объёма работ.</ArticleParagraph1>
      <ArticleParagraph1>
        За помощь в сопровождении сделки цена обычно фиксированная. В Москве это около 150–200 тыс. рублей, в регионах —
        ниже.
      </ArticleParagraph1>
      <ArticleParagraph1>
        Если риелтор подбирает для вас объекты, ездит на просмотры, ведёт переговоры и сопровождает сделку, комиссия
        обычно составляет 1,5–2% от стоимости квартиры.
      </ArticleParagraph1>
      <ArticleParagraph1>
        При покупке новостройки риелтор обычно получает вознаграждение напрямую от застройщика, поэтому для вас подбор
        объекта и сопровождение сделки будут бесплатными.
      </ArticleParagraph1>
    </div>
  );
};
